export const TYPES_SEARCH = {
  SEARCH_NAME: 'SEARCH_NAME',
  SEARCH_CLAIM_NUMBER: 'SEARCH_CLAIM_NUMBER',
  SEARCH_ADHESION_NUMBER: 'SEARCH_ADHESION_NUMBER',
  SEARCH_OTHERS: 'SEARCH_OTHERS',
  SEARCH_NUMBER: 'SEARCH_NUMBER',
};

export const returnComponenet = {
  FIRST: 'first Componet',
  EMPTY: 'empty search value',
  'ARRAY-RESULT': 'array result',
};

export const statusClaim = [
  { code: 1, label: 'Valide', styleColor: '#00ab7d' },
  { code: 2, label: 'Résiliée', styleColor: '#a1a1a1' },
  { code: 5, label: 'Renoncée', styleColor: '#a1a1a1' },
  { code: 8, label: 'Effectif', styleColor: '#a1a1a1' },
  { code: 11, label: 'Suspendue', styleColor: '#ef9f27' },
  { code: 15, label: 'Annulé', styleColor: '#a1a1a1' },
  { code: 22, label: 'Clos', styleColor: '#a1a1a1' },
  { code: 28, label: 'Refusé', styleColor: '#a1a1a1' },
  { code: 99, label: 'en attente', styleColor: '#f1170c' },
];

export const statusClaimsV2 = [
  { code: 75, label: 'Dossier en cours', styleColor: '#00ab7d' },
  { code: 6, label: 'Accepté-Indemnisation', styleColor: '#c7c7c7' },
  { code: 13, label: 'Prescrit', styleColor: '#c7c7c7' },
  { code: 7, label: 'Refusé', styleColor: '#cc0000' },
  { code: 24, label: 'Accepté-Indemnisé', styleColor: '#c7c7c7' },
  { code: 11, label: 'Sans suite', styleColor: '#c7c7c7' },
];

export enum FMIPResponse {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  UNKNOWN = "UNKNOWN",
  ERROR = "ERROR",
  AVAILABLE = "AVAILABLE",
  NOCONTROLE = "NOCONTROLE",
  MAX_ATTEMPTS_REACHED = "MAX_ATTEMPTS_REACHED"
}